import React from 'react';
import { motion } from 'framer-motion';
export function AboutSection() {
  return <section id="about" className="px-[60px] py-[140px] bg-gradient-to-br from-[#B5EAD7] to-[#C5F467]" data-id="element-1029">
      <div className="max-w-[1400px] mx-auto" data-id="element-1030">
        <div className="grid lg:grid-cols-2 gap-[80px] items-center" data-id="element-1031">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-1032">
            <div className="inline-flex items-center px-4 py-2 rounded bg-[#1A3D3A] text-white mb-8" style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: '12px',
            fontWeight: 600,
            letterSpacing: '3px',
            lineHeight: 1.0,
            borderRadius: '4px'
          }} data-id="element-1033">
              ABOUT US
            </div>
            <h2 className="text-[#1A3D3A] mb-8" style={{
            fontFamily: "'Cormorant Garamond', serif",
            fontSize: 'clamp(40px, 5vw, 56px)',
            fontWeight: 500,
            lineHeight: 1.1,
            letterSpacing: '-1px'
          }} data-id="element-1034">
              Built by Founders,
              <br data-id="element-1035" />
              For Founders
            </h2>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="space-y-6" data-id="element-1036">
            <p className="text-[#3D5654]" style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: '17px',
            fontWeight: 400,
            lineHeight: 1.8
          }} data-id="element-1037">
              CofounderFit is a research initiative created by two founders
              who've experienced the real highs and lows of building companies
              together.
            </p>
            <p className="text-[#3D5654]" style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: '17px',
            fontWeight: 400,
            lineHeight: 1.8
          }} data-id="element-1038">
              We learned early that the relationship at the top influences
              nearly every major outcome—yet leaders receive few tools to
              strengthen the one dynamic that drives execution, performance, and
              growth.
            </p>
            <p className="text-[#3D5654]" style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: '17px',
            fontWeight: 400,
            lineHeight: 1.8
          }} data-id="element-1039">
              Our work synthesizes findings from Harvard Business School's
              founder-dynamics research, First Round Capital's decade-long
              portfolio analysis, the UNSW-Oxford personality study published in
              Nature Scientific Reports, and Gallup's extensive work on team
              performance.
            </p>
            <p className="text-[#3D5654]" style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: '17px',
            fontWeight: 400,
            lineHeight: 1.8
          }} data-id="element-1040">
              We interview founders, senior teams, advisors, coaches, investors,
              and operators to understand what the data alone can't tell us—the
              lived experience of partnership.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}